import styled from 'styled-components';

const Container = styled.div`
  background: hsl(0, 70%, 70%);
  padding: 1rem;
  border-radius: 10px 10px 0 0;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  div {
    display: flex;
    align-items: center;
  }

  img {
    border-radius: 1rem;
    margin-right: 1rem;
  }
`;

export default Container;
